import { render } from "./CNGFooter.vue?vue&type=template&id=b0a119b6&scoped=true"
import script from "./CNGFooter.vue?vue&type=script&lang=js"
export * from "./CNGFooter.vue?vue&type=script&lang=js"

import "./CNGFooter.vue?vue&type=style&index=0&id=b0a119b6&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a119b6"]])

export default __exports__